import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function Reset() {
  const theme = useTheme();
  return (


    <Typography variant='h5'>
      Reset Pattern Page
    </Typography>


  );
}